import ApplicationOwner from "components/Application/ApplicationOwner"
import ConsumptionItems from "components/Services/FormComponents/ConsumptionItems"
import OtherConsumptionItems from "components/Services/FormComponents/OtherConsumptionItems"

import { useEffect, useState } from "react"
import { Row, Col, Alert } from "reactstrap"
import {
  AvForm,
  AvField,
  AvRadio,
  AvRadioGroup,
} from "availity-reactstrap-validation"

import Application from "services/applications/Application.service"

let officerInfo = JSON.parse(localStorage.getItem("authUser"))
let appService = new Application(officerInfo)

const EditPlasticDetails = props => {
  const [plasticTypes, setplasticTypes] = useState([])
  const [plasticTypesRaw, setplasticTypesRaw] = useState()
  const [measures, setmeasures] = useState()
  const [measureId, setmeasureId] = useState("")
  const [consumptionId, setconsumptionId] = useState("")
  const [hideOtherPlasticTypeName, sethideOtherPlasticTypeName] = useState(true)
  const [consumptionAreas, setconsumptionAreas] = useState([])
  const [measuresRaw, setmeasuresRaw] = useState()
  const [showPieces, setshowPieces] = useState(false)
  const [consumptionTypeColumn, setconsumptionTypeColumn] = useState(6)
  const [hideOtherConsumptionTypeName, sethideOtherConsumptionTypeName] =
    useState(true)
  const [usagePreview, setusagePreview] = useState("")
  const [consumptionAreaOtherItems, setconsumptionAreaOtherItems] = useState({
    count: 0,
    data: [],
  })
  const [localSuppliers, setlocalSuppliers] = useState([])
  const [localSuppliersRaw, setlocalSuppliersRaw] = useState([])
  const [showLocalSuppliers, setshowLocalSuppliers] = useState(false)
  const [consumptionAreaItems, setconsumptionAreaItems] = useState([])
  const [importPurchase, setimportPurchase] = useState({
    purchase: true,
    import: false,
    import_single: false,
    purchase_single: false,
  })
  const [applicantConsumptionAreaItems, setapplicantConsumptionAreaItems] =
    useState([])

  const [importPurchaseUpdate, setimportPurchaseUpdate] = useState("")
  const [isMedicalUse, setisMedicalUse] = useState(false)
  const [countOtherItems, setcountOtherItems] = useState(0)
  const [renderOtherItems, setrenderOtherItems] = useState(false)
  const [itemsUsage, setitemsUsage] = useState("")
  const [error, seterror] = useState()

  // Fields to modify
  // plastic_type_id
  // quantity_measure_id
  // plasticsfinishedusage
  // consumption_area_id
  // quantity

  useEffect(() => {
    // seterror("Error encountered while submitting application")
    // console.log("app details", props.appDetails)
    // console.log("finished --> ", props.appDetails.auth_plastic_bags)
    appService.getPlasticTypes().then(response => {
      const options = response.data.map((type, index) => (
        <option key={index} value={type.id}>
          {type.name}
        </option>
      ))
      setplasticTypes(options)
      setplasticTypesRaw(response.data)
    })

    if (props.appDetails.auth_plastic_bags.piece_weight != null) {
      setshowPieces(true)
    } else {
      setshowPieces(false)
    }

    fetchQuantityMeasures()
    fetchConsumptionAreas()
    fetchSelectedConsumptionItems()
  }, [])

  const fetchSelectedConsumptionItems = () => {
    var user_selected_items =
      props.appDetails.application_consumption_area_items
    // console.log(user_selected_items)
    appService
      .getConsumptionAreaItems(
        props.appDetails.auth_plastic_bags.consumption_area_id
      )
      .then(response => {
        if (response.status) {
          var items = response.data.map(item => {
            return {
              id: item.id,
              name: item.name,
              checked: false,
            }
          })

          const user_items = user_selected_items.map(item => {
            return {
              id: item.consumption_area_item.id,
              name: item.consumption_area_item.name,
              checked: true,
            }
          })

          var mergedConsumptionItems = items.concat(user_items)

          // remove duplicates
          let filteredItems = mergedConsumptionItems.filter(
            (ele, ind) =>
              ind ===
              mergedConsumptionItems.findIndex(
                elem => elem.jobid === ele.jobid && elem.id === ele.id
              )
          )

          // selected consumption area items
          var selected_items = user_selected_items.map(
            item => item.consumption_area_item_id
          )
          filteredItems.forEach(item => {
            if (selected_items.includes(item.id)) {
              item.checked = true
            }
          })

          setconsumptionAreaItems(filteredItems)
        }
      })
  }

  const fetchQuantityMeasures = () => {
    appService.getQuantityMeasures().then(response => {
      if (response.status) {
        const meas = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setmeasures(meas)
        setmeasuresRaw(response.data)
      }
    })
  }

  const fetchConsumptionAreas = () => {
    appService.getConsumptionAreas().then(response => {
      if (response.status) {
        const areas = response.data
          .filter(item => item.name != "Other" && item.name != "Meet Supplying")
          .map((item, index) => {
            return (
              <option key={index} value={item.id}>
                {item.name}
              </option>
            )
          })

        setconsumptionAreas(areas)
      }
    })
  }

  const onChangePlasticType = event => {
    if (event.target.value !== "") {
      // get plastic name
      var plasticTypeName =
        event.target.options[event.target.selectedIndex].text

      if (plasticTypeName == "Other") {
        sethideOtherPlasticTypeName(false)
      } else {
        sethideOtherPlasticTypeName(true)
      }

      setplasticNameUpdate(plasticTypeName)
    }
  }

  const handleQuantityMeasureChange = e => {
    const pieces = measuresRaw
      .filter(item => item.name == "Pieces")
      .map(item => {
        return { id: item.id, name: item.name }
      })

    if (pieces.length > 0) {
      if (pieces[0].id == e.target.value) {
        setshowPieces(true)
      } else {
        setshowPieces(false)
      }
    }
  }

  const onChangeConsumptionArea = e => {
    const area_name = e.target.options[e.target.selectedIndex].text
    setusagePreview(area_name)

    if (area_name == "Medical Use") {
      setisMedicalUse(true)
    } else {
      setisMedicalUse(false)
    }

    setitemsUsage("Choose the items to be used for " + area_name)

    setconsumptionId(e.target.value)
    setrenderOtherItems(true)

    // fetch items in consumption area
    appService.getConsumptionAreaItems(e.target.value).then(response => {
      if (response.status) {
        const items = response.data.map(item => {
          return {
            id: item.id,
            name: item.name,
            checked: false,
          }
        })

        setconsumptionAreaItems(items)
      }
    })

    if (area_name == "Other") {
      setconsumptionTypeColumn(4)
      sethideOtherConsumptionTypeName(false)
    } else {
      setconsumptionTypeColumn(6)
      sethideOtherConsumptionTypeName(true)
    }

    // changes April 5, 2023
    // If consumption area changes, set other items to empty
    setconsumptionAreaOtherItems({ count: 0, data: [] })
  }

  const updateConsumptionItems = (index, status) => {
    var items = consumptionAreaItems
    items[index]["checked"] = status

    setconsumptionAreaItems(items)
  }

  const addOtherConsumptionItems = item => {
    let items = consumptionAreaOtherItems.data
    if (items.includes(item)) {
      return
    }
    items.push({ id: null, name: item, checked: true })
    setconsumptionAreaOtherItems({ count: items.length, data: items })
  }

  const updateOtherConsumptionItems = itemIndex => {
    let items = consumptionAreaOtherItems.data

    items[itemIndex]["checked"] = !items[itemIndex]["checked"]

    setconsumptionAreaOtherItems({ count: items.length, data: items })
  }

  // Changes Oct 15 2022
  const fetchLocalSuppliers = () => {
    appService.getLocalSuppliers().then(response => {
      if (response.status) {
        const suppliers = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setlocalSuppliers(suppliers)
        setlocalSuppliersRaw(response.data)
      }
    })
  }

  const onChangeImportPurchase = e => {
    var type = e.target.value
    type = type.toLowerCase()

    // data to send to backend
    // In the backend, there are four fields for import/purchase
    // import and use single-use plastics
    // Purchase and use single-use plastics

    // import and use plastic carry bags
    // Purchase and use plastic carry bags

    var data = {
      purchase: false,
      import: false,
      import_single: false,
      purchase_single: false,
    }

    if (type === "purchase" || type === "purchase_single") {
      setshowLocalSuppliers(true)
    } else {
      setshowLocalSuppliers(false)
    }

    if (e.target.value === "") {
      return
    } else {
      data[e.target.value] = true
      setimportPurchase(data)
      // set data
    }
  }

  const saveApplication = applicationDetails => {
    // console.log({
    //   ...applicationDetails,
    //   consumption_area_items: consumptionAreaItems,
    //   application_id: props.appDetails.id,
    // })

    var consumptionItems = consumptionAreaItems
      .filter(item => item.checked)
      .map(item => {
        return item.id
      })

    var consumptionItemsNames = consumptionAreaItems
      .filter(item => item.checked)
      .map(item => {
        return item.name
      })

    var other_selected_items_names = consumptionAreaOtherItems.data
      .filter(item => item.checked)
      .map(item => item.name)

    var other_selected_items = consumptionAreaOtherItems.data
      .filter(item => item.checked)
      .map(item => item)

    // If single use plastics are for medical use, then consumption area items are not required.
    if (!isMedicalUse) {
      if (consumptionItems.length < 1 && other_selected_items.length < 1) {
        alert("Please choose the items you will be packaging")
        return
      }
    }
    if (confirm("Do you want to proceed with saving the application?")) {
      appService
        .saveApplication({
          ...applicationDetails,
          application_id: props.appDetails.id,
          consumption_area_items: consumptionItems,
          other_selected_items: other_selected_items,
          other_selected_items_names: other_selected_items_names,
          consumptionItemsNames: consumptionItemsNames,
        })
        .then(response => {
          if (response.status) {
            // setsubmitted(true)
            // console.log(response)
            window.location.reload()
          } else {
            seterror("Error encountered while updating the application")
            setloading(false)
          }
        })
    }
  }

  return (
    <>
      <AvForm
        onValidSubmit={(e, v) => {
          saveApplication(v)
        }}
      >
        {error ? <Alert color="danger">{error}</Alert> : null}
        <Row>
          <Col md={12}>
            <Row className="mb-3">
              <div>
                <AvField
                  onChange={onChangePlasticType}
                  type="select"
                  name="plastic_type_id"
                  label="Select Plastic Type"
                  value={props.appDetails.auth_plastic_bags.plastic_type_id}
                  required
                >
                  <option value="">--select--</option>
                  {plasticTypes}
                </AvField>
              </div>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <Row className="mb-3">
              <div>
                <AvField
                  type="select"
                  name="quantity_measure_id"
                  label="Quantity measure"
                  required
                  value={props.appDetails.auth_plastic_bags.quantity_measure_id}
                  onChange={handleQuantityMeasureChange}
                >
                  <option value="">--select--</option>
                  {measures}
                </AvField>
              </div>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <Row className="mb-3">
              <div>
                <AvField
                  name="quantity"
                  type="number"
                  className="form-control"
                  label="Quantity of plastic"
                  value={props.appDetails.auth_plastic_bags.quantity}
                  required
                />
              </div>
            </Row>
          </Col>
        </Row>

        {showPieces ? (
          <Row>
            <Col md={12}>
              <Row className="mb-3">
                <div>
                  <AvField
                    type="number"
                    name="piece_weight"
                    label="Weight of one piece (g)"
                    required
                    value={props.appDetails.auth_plastic_bags.piece_weight}
                  ></AvField>
                </div>
              </Row>
            </Col>
          </Row>
        ) : null}

        <Row>
          <h5>Where will the finished product be sold or used?</h5>
          <AvRadioGroup
            inline
            name="plasticsFinishedUsage"
            // label="Where will the finished product be sold?"
            value={props.appDetails.auth_plastic_bags.plastics_finished_usage}
            required
          >
            <AvRadio customInput label="Local Sale" value="Local Sale" />
            <AvRadio customInput label="Export" value="Export" />
            <AvRadio
              customInput
              label="Both local sale and export"
              value="Both"
            />
          </AvRadioGroup>
        </Row>

        <Row>
          <Col md={12}>
            <input type="hidden" name="usage_preview" value={usagePreview} />
            <Row className="mb-3">
              <div>
                <AvField
                  type="select"
                  name="consumption_area_id"
                  label="Select Application Area"
                  required
                  value={props.appDetails.auth_plastic_bags.consumption_area_id}
                  onChange={onChangeConsumptionArea}
                >
                  <option value="">--select--</option>
                  {consumptionAreas}
                </AvField>
              </div>
            </Row>
          </Col>
        </Row>

        <Row>
          {consumptionAreaItems.length > 0 ? <h5>{itemsUsage}</h5> : null}
          <h4>Select Consumption Area Items</h4>
          {!isMedicalUse ? (
            <div>
              <ConsumptionItems
                data={consumptionAreaItems}
                update={updateConsumptionItems}
              />
            </div>
          ) : null}
        </Row>

        <Row>
            {/* <hr></hr> */}
            <div>
              <OtherConsumptionItems
                data={consumptionAreaOtherItems}
                add={addOtherConsumptionItems}
                update={updateOtherConsumptionItems}
              />
            </div>
          </Row>

        <br></br>
        <button className="btn btn-primary pull-right" type="submit">
          Update Application Details
        </button>
      </AvForm>
    </>
  )
}

export default EditPlasticDetails
